export const getYears = () => {
    const start = 2004;
    const currentYear = new Date().getFullYear();
    const options = [];
    for(let i = currentYear; i >= start; i--)
        options.push({ id: i, nombre: i })
    return options;
}
